/** 开发代理只接受本机图片服务，不把任意 URL 变成代理目标。 */
export function localImageOrigin(value = 'http://127.0.0.1:3302'): string {
  const parsed = new URL(value);
  if (
    parsed.protocol !== 'http:' ||
    parsed.hostname !== '127.0.0.1' ||
    !parsed.port ||
    parsed.username ||
    parsed.password ||
    parsed.pathname !== '/' ||
    parsed.search ||
    parsed.hash
  )
    throw new Error('本地图片代理必须是带端口的 127.0.0.1 HTTP origin');
  return parsed.origin;
}
